import React, {useEffect } from 'react';
import { useTranslation } from "react-i18next";
import LazyLoad from "react-lazyload";
import ReactMarkdown from 'react-markdown'
import { Link } from "react-router-dom";
import { browserName, isIOS } from 'react-device-detect';

const DIAGEO_STYLE = `#diageo-footer{background-color:transparent!important;color:#000;gap:.25rem;font-size:14px!important;line-height:30px!important;font-weight:600!important}#diageo-footer ul{row-gap:0!important;column-gap:25px!important}#diageo-footer div,#diageo-footer span,#diageo-footer ul,#diageo-footer ul li,#diageo-footer ul li a{font-size:14px!important;line-height:25px!important;font-weight:700!important;font-family:urw_geometricbold!important}#diageo-footer ul li a:hover,#diageo-footer ul li button:hover{text-decoration:underline}#diageo-footer ul li a:focus,#diageo-footer ul li button:focus{outline:0;border:none;box-shadow:none}#diageo-footer ul li a:focus-visible,#diageo-footer ul li button:focus-visible{outline:3px solid #562274!important;outline-offset:2px!important}.diageo-bottom-div{display:grid;gap:3px}@media (max-width:768px){#diageo-footer{gap:.75rem}#diageo-footer ul{display:grid!important;grid-template-columns:1fr 1fr!important;gap:12px 20px!important;padding:0!important;margin:0!important;list-style:none!important}}`;

const injectDiageoStyles = () => {
    const diageoFooter = document.getElementById('diageo-footer-wrap');
    const footerContainer = document.getElementById('footer');

    if (!diageoFooter || !footerContainer) return false;
    if (!footerContainer.contains(diageoFooter)) {
        footerContainer.prepend(diageoFooter);
    }
    const shadow = diageoFooter.shadowRoot;
    if (!shadow) return false;
    const targetDiv = shadow.querySelector('ul + div');
    if (targetDiv && !targetDiv.classList.contains('diageo-bottom-div')) {
        targetDiv.classList.add('diageo-bottom-div');
    }
    const existingStyle = shadow.querySelector('style[data-custom="true"]');
    if (existingStyle) existingStyle.remove();

    const style = document.createElement('style');
    style.dataset.custom = 'true';
    style.textContent = DIAGEO_STYLE;
    shadow.appendChild(style);

    diageoFooter.classList.add('styled');

    return true;
};

const Footer = () => {
	const { t, i18n } = useTranslation(['Footer']);

    useEffect(() => {
        if (browserName === "Safari" || isIOS) {
            const footerlies = document.querySelectorAll('.media-container-row ul li a');
            if (footerlies.length) {
                footerlies.forEach((footerli) => {
                    footerli.setAttribute('style', 'font-family:urw_geometricbold');
                });
            }
        }
    }, [i18n.language]);

    useEffect(() => {
        let parentObserver = null;
        let shadowObserver = null;
        let intervalId = null;

        const applyStyles = () => {
            const success = injectDiageoStyles();
            if (success) {
                const diageoFooter = document.getElementById('diageo-footer-wrap');
                if (diageoFooter && diageoFooter.shadowRoot && !shadowObserver) {
                    shadowObserver = new MutationObserver(() => {
                        const shadow = diageoFooter.shadowRoot;
                        const hasStyle = shadow.querySelector('style[data-custom="true"]');
                        if (!hasStyle || shadow.lastElementChild !== hasStyle) {
                            injectDiageoStyles();
                        }
                    });
                    shadowObserver.observe(diageoFooter.shadowRoot, {
                        childList: true,
                        subtree: true,
                    });
                }
            }
        };

        // 1. Try immediately
        applyStyles();

        // 2. Observe changes in the parent container
        const footerContainer = document.getElementById('footer');
        if (footerContainer) {
            parentObserver = new MutationObserver(() => {
                applyStyles();
            });
            parentObserver.observe(footerContainer, {
                childList: true,
                subtree: true,
            });
        }

        // 3. Fallback interval check for 10 seconds (runs every 500ms)
        let counter = 0;
        intervalId = setInterval(() => {
            applyStyles();
            counter++;
            if (counter > 20) {
                clearInterval(intervalId);
            }
        }, 500);

        return () => {
            if (parentObserver) parentObserver.disconnect();
            if (shadowObserver) shadowObserver.disconnect();
            if (intervalId) clearInterval(intervalId);
        };
    }, [i18n.language]);
	return (
		<section id="footersection" className="footer foot-space">
			<div className="container">
				<div className="row pb-3">
					<div className="col-sm-8 col-md-8 col-lg-8 col-xl-5 pe-lg-6">
						<div className="item-wrapper">

							{Object.values(t("LeftFooter", { returnObjects: true })).map((item) => (
								(item.fieldType === "assets" && item.imgURL !== "") ?
									<LazyLoad className="mb-4" key={item.id} height={100}>
										<img height="100" src={item.imgURL} alt={item.alternateText} className="footer-logo-assests" />
									</LazyLoad>

									: ""
							))
							}


							{Object.values(t("LeftFooter", { returnObjects: true })).map((item) => (
								(item.fieldType === "rich_text" && item.value !== "") ?
									<p key={item.id} className="">
										<ReactMarkdown components={{ p: React.Fragment }}>{item.value}</ReactMarkdown>
									</p>
									: ""
							))
							}

						</div>
					</div>
					<div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 pe-lg-5">
						<div className="item-wrapper mt-3 mt-lg-5">
							{Object.values(t("centerFooter", { returnObjects: true })).map((item) => (
								(item.fieldType === "h3" && item.value !== "") ?
									<div key={item.id} className="mailheading">
										<ReactMarkdown components={{ p: React.Fragment }}>{item.value}</ReactMarkdown>
									</div>
									: ""
							))
							}

							{Object.values(t("centerFooter", { returnObjects: true })).map((item) => (
								(item.fieldType === "email_link" && item.URL !== "") ?
									<p key={item.id} className="foot-mail">

										<Link
											to='#'
											onClick={(e) => {


												window.dataLayer = window.dataLayer || [];
												window.dataLayer.push({
												  event: "customEvent",
												  eventCategory: "Button",
												  eventAction: "Click",
												  eventLabel: "contact_email",
												  eventValue: '',
												});



												window.location.href = 'mailto:'+item.URL;
												e.preventDefault();
											}}
										>
											<ReactMarkdown components={{ p: React.Fragment }}>{item.URL}</ReactMarkdown>
										</Link>

									</p>
									: ""
							))
							}
						</div>
					</div>
					<div className="col-sm-6 col-md-4 col-lg-4 col-xl-4 pe-lg-5">
						<div className="item-wrapper">
							{Object.values(t("rightFooter", { returnObjects: true })).map((item) => (
								(item.fieldType === "assets" && item.imgURL !== "") ?
									<LazyLoad className="mb-4" key={item.id} height={100}>
										<img height="100" src={item.imgURL} alt={item.alternateText} className="footer-logo-assests" />
									</LazyLoad>

									: ""
							))
							}


							{Object.values(t("rightFooter", { returnObjects: true })).map((item) => (
								(item.fieldType === "plain_text" && item.value !== "") ?
									<p key={item.id} className="">
										<ReactMarkdown components={{ p: React.Fragment }}>{item.value}</ReactMarkdown>
									</p>
									: ""
							))
							}

							{Object.values(t("rightFooter", { returnObjects: true })).map((item) => (
								(item.fieldType === "link" && item.URL !== "") ?
									<a key={item.id} href={item.URL} className="drinkiq" target="_blank" rel="noopener noreferrer">
										<ReactMarkdown components={{ p: React.Fragment }}>{item.title}</ReactMarkdown>
									</a>
									: ""
							))
							}


						</div>
					</div>
				</div>
				<div className="media-container-row">
					<div id="footer"></div>
				</div>

			</div>
		</section>

	)
}

export default Footer
